import { Reveal, Eyebrow } from "@/components/Reveal";

const COPY = {
  privacy: {
    title: "Privacy Policy",
    updated: "Last updated: October 2026",
    sections: [
      {
        h: "Who We Are",
        p: [
          "Fairlume LLC (\u201cFairlume,\u201d \u201cwe,\u201d \u201cus\u201d) is a commercial lighting solutions company based in Gilbert, Arizona. This policy explains what information we collect through this website, why we collect it, and the choices you have.",
        ],
      },
      {
        h: "Information We Collect",
        p: [
          "When you submit a quote request or contact form, we collect the details you provide: your name, company or course name, business email, phone number, project location, facility details, project description, and any site photos or drawings you choose to upload.",
          "Access to our administrative dashboard is restricted to authorized Fairlume staff who sign in with Google; we receive only their name and email address for access control.",
          "We do not run advertising trackers on this website.",
        ],
      },
      {
        h: "How We Use Your Information",
        p: [
          "We use the information you submit solely to respond to your inquiry, assess your project, prepare proposals, and communicate with you about your project.",
          "We do not sell your personal information, and we do not share it with third parties for their marketing purposes.",
        ],
      },
      {
        h: "Storage and Security",
        p: [
          "Project briefs and uploaded files are stored securely and are accessible only to the Fairlume team. Administrative access is protected by Google sign-in and limited to authorized accounts.",
        ],
      },
      {
        h: "Email Communications",
        p: [
          "When you submit a form, we send you a confirmation email and notify our team through our email delivery provider. These messages are transactional and relate only to your inquiry. You can reach us or opt out of further communication at any time by replying to any message or emailing fairlumeinfo@gmail.com.",
        ],
      },
      {
        h: "Service Providers",
        p: [
          "We use a small number of service providers to operate this website — specifically Google for staff sign-in and an email delivery service for transactional messages. These providers receive only the information needed to perform their function.",
        ],
      },
      {
        h: "Your Choices",
        p: [
          "You may request a copy, correction, or deletion of the information we hold about you at any time by emailing fairlumeinfo@gmail.com. We will honor deletion requests except where we must retain records for legitimate business or legal purposes.",
        ],
      },
      {
        h: "Changes to This Policy",
        p: [
          "If we update this policy, the revised version will be posted on this page with an updated date.",
        ],
      },
      {
        h: "Contact",
        p: [
          "Fairlume LLC · Gilbert, Arizona · fairlumeinfo@gmail.com · +1 (480) 953-0059",
        ],
      },
    ],
  },
  terms: {
    title: "Terms of Use",
    updated: "Last updated: October 2026",
    sections: [
      {
        h: "Acceptance",
        p: [
          "By using this website, you agree to these Terms of Use. If you do not agree, please do not use the site.",
        ],
      },
      {
        h: "Informational Purpose",
        p: [
          "Content on this website is provided for general informational purposes. Estimates produced by the revenue calculator are illustrative gross revenue scenarios only — actual results depend on demand, operating costs, seasonality, capacity, and other factors, and are not guaranteed.",
        ],
      },
      {
        h: "Quotes and Contracts",
        p: [
          "Submitting a quote request does not create a binding agreement. All projects are subject to a site assessment, a formal written proposal, and an executed contract.",
        ],
      },
      {
        h: "Independent Installation Contractors",
        p: [
          "Fairlume does not perform installation work and does not employ installation crews. Where installation is required, we may recommend independent contractors. Those contractors are not employees or agents of Fairlume, and all installation work is performed under their own licenses, insurance, and agreements with you.",
        ],
      },
      {
        h: "Intellectual Property",
        p: [
          "The Fairlume name, logo, and the content and imagery on this website are the property of Fairlume LLC and may not be reproduced without written permission.",
        ],
      },
      {
        h: "No Warranties; Limitation of Liability",
        p: [
          "This website is provided \u201cas is\u201d without warranties of any kind. To the fullest extent permitted by law, Fairlume LLC is not liable for any indirect or consequential damages arising from use of this website or reliance on its content.",
        ],
      },
      {
        h: "Contact",
        p: [
          "Fairlume LLC · Gilbert, Arizona · fairlumeinfo@gmail.com · +1 (480) 953-0059",
        ],
      },
    ],
  },
};

export default function Legal({ kind }) {
  const page = COPY[kind] || COPY.privacy;
  return (
    <main className="pt-40 pb-24 px-4 sm:px-8 lg:px-16 max-w-3xl mx-auto" data-testid={`legal-${kind}`}>
      <Reveal>
        <Eyebrow>Fairlume LLC</Eyebrow>
        <h1 className="font-display font-bold uppercase tracking-tight text-3xl sm:text-4xl">{page.title}</h1>
        <p className="mt-4 font-mono-tech text-[11px] uppercase tracking-[0.2em] text-white/35">{page.updated}</p>
        {page.sections.map((s) => (
          <section key={s.h} className="mt-10">
            <h2 className="font-display font-semibold text-lg tracking-tight text-[#A7D7A0]">{s.h}</h2>
            {s.p.map((para, i) => (
              <p key={i} className="mt-3 text-muted-green text-sm sm:text-base leading-relaxed">{para}</p>
            ))}
          </section>
        ))}
      </Reveal>
    </main>
  );
}
